import axios from "axios";

// 正式
const BASE_URL =
  window.location.host === "newrank.cn" ||
  window.location.host === "www.newrank.cn"
    ? "https://gw.newrank.cn"
    : "http://test-gw.newrank.cn:18080";

const frozenAxios = axios.create({
  baseURL: BASE_URL,
  headers: { "N-Token": "57e1219856644286be45fee9208c4a1c" },
  withCredentials: true,

});

export default frozenAxios;



// WEBPACK FOOTER //
// ./src/api/frozenAxios.js